import { render, staticRenderFns } from "./DetailCommandeFournisseur.vue?vue&type=template&id=2a67bbf6&"
import script from "./DetailCommandeFournisseur.vue?vue&type=script&lang=js&"
export * from "./DetailCommandeFournisseur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a67bbf6')) {
      api.createRecord('2a67bbf6', component.options)
    } else {
      api.reload('2a67bbf6', component.options)
    }
    module.hot.accept("./DetailCommandeFournisseur.vue?vue&type=template&id=2a67bbf6&", function () {
      api.rerender('2a67bbf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/DetailCommandeFournisseur.vue"
export default component.exports